<section class="main">
    <h3>Add new unit</h3>

    <div class="mb-3">
        <label>Select village</label>
        <div class="dropdown mb-0 ">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{villageName}}
                <img src="assets/images/mangeunit/arrow.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                <li (click)="chooseVillage(item)" *ngFor="let item of vilage_arr">
                    <a class="dropdown-item">
                        {{item.name}}
                    </a>
                </li>
            </ul>
        </div>
        <span class="erorrMasge" *ngIf="erorrVillage"> Village is required</span>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label>Unit name</label>
                <input (input)="getUnitName($event)" [(ngModel)]="unitName" placeholder="EX. Home" type="text" class="form-control">
                <span class="erorrMasge" *ngIf="erorrUnitName">Unit name is required</span>
            </div>
        </div>
        <div class="col">
            <div class="form-group">
                <label>Unit ID</label>
                <input (input)="getUnitId($event)" [(ngModel)]="unitId" placeholder="Unit unique ID" type="text" class="form-control">
                <span class="erorrMasge" *ngIf="erorrUnitId">Unit ID is required</span>
            </div>
        </div>
    </div>

    <div class="mt-3">
        <label>Unit type</label>
        <div class="dropdown mb-0 ">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{typename}}
                <img src="assets/images/mangeunit/arrow.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li (click)="chooseType(item)" *ngFor="let item of type_arr">
                        <a class="dropdown-item">
                            {{item.name}}
                        </a>
                    </li>
                </ul>
        </div>
        <span class="erorrMasge" *ngIf="erorrUnittype">Unit Type is required</span>
    </div>



    <div class="addUnits d-flex justify-content-end mt-5 mb-2">
        <div>
            <button   mat-dialog-close class="btn me-2">Cancel</button>
            <button class="btn addUnit" (click)="addUnit()">Add unit</button>
        </div>
    </div>
</section>